<template>
    <div>
        <v-card flat
        style="border-radius: 5px;border: solid #E1E1E1 1px;" width="600">
                    <v-card-text class="text-center title black--text">
                            Contact Us
                    </v-card-text>
                    <v-card-text>
                        <v-form @submit.prevent="enviarEmails()">
                            <label>
                                <span class="black--text">
                                <strong>First Name</strong> 
                                </span>  <br> 
                                <input type="text" v-model="firstname" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>Last Name</strong> 
                                </span>  <br>
                                <input type="text" v-model="lastname" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>Bussiness Name</strong> 
                                </span>  <br>
                                <input type="text" v-model="bussiness" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>Address</strong> 
                                </span>  <br>
                                <input type="text" v-model="address" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>State</strong> 
                                </span>  <br>
                                <input type="text" v-model="states" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>Zip Code</strong> 
                                </span>  <br>
                                <input type="text" v-model="zipcode" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>Phone Number</strong> 
                                </span>  <br>
                                <input type="text" v-model="cellphone" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>Email</strong> 
                                </span>  <br>
                                <input type="email" v-model="email" required class="inputTxt">
                            </label>
                            <label>
                                <span class="black--text">
                                <strong>Notes</strong> 
                                </span>  <br>
                                <textarea type="text" v-model="notes" required class="inputArea"></textarea>
                            </label>
                            <v-btn type="submit" class="btns my-2" text>
                            <strong>
                               Order Now  
                            </strong>
                        </v-btn>
                        </v-form>
                        
                    </v-card-text>
                </v-card>
    </div>
</template>

<style>
.inputArea {
    background-color: #fff;
    height: 80px;
    padding: 3px 7px;
    line-height: normal;
    color: #333;
    border: solid #a6a6a6 1px;
    border-top-color: #949494;
    border-radius: 3px;
    box-shadow: 0 1px 0 rgba(255,255,255,.5), 0 1px 0 rgba(0,0,0,.07) inset;
    outline: 0;
    font-weight: 500;
    text-align: center;
    width: 100%;
}
.inputArea:focus {
    border-color: #e77600;
    box-shadow: 0 0 3px 2px rgba(228,121,17,.5);
}

.inputTxt {
    background-color: #fff;
    height: 31px;
    padding: 3px 7px;
    line-height: normal;
    color: #333;
    border: solid #a6a6a6 1px;
    border-top-color: #949494;
    border-radius: 3px;
    box-shadow: 0 1px 0 rgba(255,255,255,.5), 0 1px 0 rgba(0,0,0,.07) inset;
    outline: 0;
    font-weight: 500;
    text-align: center;
    width: 100%;
}
.inputTxt:focus {
    border-color: #e77600;
    box-shadow: 0 0 3px 2px rgba(228,121,17,.5);
}
.btns {
    
    background: rgba(255,183,0,1);
    background: -moz-linear-gradient(top, rgba(255,183,0,1) 0%, rgba(232,139,0,1) 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255,183,0,1)), color-stop(100%, rgba(232,139,0,1)));
    background: -webkit-linear-gradient(top, rgba(255,183,0,1) 0%, rgba(232,139,0,1) 100%);
    background: -o-linear-gradient(top, rgba(255,183,0,1) 0%, rgba(232,139,0,1) 100%);
    background: -ms-linear-gradient(top, rgba(255,183,0,1) 0%, rgba(232,139,0,1) 100%);
    background: linear-gradient(to bottom, rgba(255,183,0,1) 0%, rgba(232,139,0,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffb700', endColorstr='#e88b00', GradientType=0 );
    color: #111;
    padding: 10px 20px 10px 20px;
}
    .rous {
        text-decoration: none;
        color: gray;
        font-size: 15px;
    }
    .rous:hover {
        text-decoration: underline;
    }
</style>

<script>
let emailjs = require('emailjs-com') 
export default {
    data(){
        return {
imageDialog:'',bussiness:'',id: this.$route.params.id, rating: 5,dialog: false,
            firstname:'', lastname:'',email:'',notes:'', quantity:'', cellphone:'', zipcode: '',
            states: '', address:''
        }
    },
    methods:{
        async enviarEmails(){
            try {
                let data = {
            from_email: this.email,
            from_name: this.firstname,
            bussiness: this.bussiness,
            to_email: 'luigicampos86@gmail.com',
            to_name: 'Luis Campos',
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.email,
            state: this.states,
            zipcode: this.zipcode,
            cellphone: this.cellphone,
            notes: this.notes,
            address: this.address
            }
            emailjs.send("gmail", "template_LDLGkoDV", data) 
            .then(res=>{ 
                if (res.text === "OK") {
                    alert("Thank you for your request. You will be contacted within 24 hours.");
                    this.firstname = '' 
                    this.lastname = ''
                    this.bussiness = ''
                    this.cellphone = ''
                    this.address = ''
                    this.zipcode = ''
                    this.cellphone = ''
                    this.states = ''
                    this.notes = ''
                }
            }).catch(e=>{
                console.log(e.message)
            })
            } catch (error) {
                alert(error.message) 
            }
            finally {
                
            }
        }
    }
}
</script>